module.exports = __webpack_public_path__ + "img/pirate.e3c68482.svg";